"use strict";

var _createForOfIteratorHelper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Options = void 0;

var Interactivity_1 = require("./Interactivity/Interactivity");

var ParticlesOptions_1 = require("./Particles/ParticlesOptions");

var BackgroundMask_1 = require("./BackgroundMask/BackgroundMask");

var Background_1 = require("./Background/Background");

var Infection_1 = require("./Infection/Infection");

var Utils_1 = require("../../Utils");

var Theme_1 = require("./Theme/Theme");

var Enums_1 = require("../../Enums");

var FullScreen_1 = require("./FullScreen/FullScreen");

var Motion_1 = require("./Motion/Motion");

var ManualParticle_1 = require("./ManualParticle");

var Responsive_1 = require("./Responsive");

var Options = /*#__PURE__*/function () {
  function Options() {
    _classCallCheck(this, Options);

    this.autoPlay = true;
    this.background = new Background_1.Background();
    this.backgroundMask = new BackgroundMask_1.BackgroundMask();
    this.fullScreen = new FullScreen_1.FullScreen();
    this.detectRetina = true;
    this.fpsLimit = 60;
    this.infection = new Infection_1.Infection();
    this.interactivity = new Interactivity_1.Interactivity();
    this.manualParticles = [];
    this.motion = new Motion_1.Motion();
    this.particles = new ParticlesOptions_1.ParticlesOptions();
    this.pauseOnBlur = true;
    this.pauseOnOutsideViewport = true;
    this.responsive = [];
    this.themes = [];
  }

  _createClass(Options, [{
    key: "fps_limit",
    get: function get() {
      return this.fpsLimit;
    },
    set: function set(value) {
      this.fpsLimit = value;
    }
  }, {
    key: "retina_detect",
    get: function get() {
      return this.detectRetina;
    },
    set: function set(value) {
      this.detectRetina = value;
    }
  }, {
    key: "backgroundMode",
    get: function get() {
      return this.fullScreen;
    },
    set: function set(value) {
      this.fullScreen.load(value);
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c;

      if (data === undefined) {
        return;
      }

      if (data.preset !== undefined) {
        if (data.preset instanceof Array) {
          var _iterator = _createForOfIteratorHelper(data.preset),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var preset = _step.value;
              this.importPreset(preset);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {
          this.importPreset(data.preset);
        }
      }

      if (data.autoPlay !== undefined) {
        this.autoPlay = data.autoPlay;
      }

      var detectRetina = (_a = data.detectRetina) !== null && _a !== void 0 ? _a : data.retina_detect;

      if (detectRetina !== undefined) {
        this.detectRetina = detectRetina;
      }

      var fpsLimit = (_b = data.fpsLimit) !== null && _b !== void 0 ? _b : data.fps_limit;

      if (fpsLimit !== undefined) {
        this.fpsLimit = fpsLimit;
      }

      if (data.pauseOnBlur !== undefined) {
        this.pauseOnBlur = data.pauseOnBlur;
      }

      if (data.pauseOnOutsideViewport !== undefined) {
        this.pauseOnOutsideViewport = data.pauseOnOutsideViewport;
      }

      this.background.load(data.background);
      this.fullScreen.load((_c = data.fullScreen) !== null && _c !== void 0 ? _c : data.backgroundMode);
      this.backgroundMask.load(data.backgroundMask);
      this.infection.load(data.infection);
      this.interactivity.load(data.interactivity);

      if (data.manualParticles !== undefined) {
        this.manualParticles = data.manualParticles.map(function (t) {
          var tmp = new ManualParticle_1.ManualParticle();
          tmp.load(t);
          return tmp;
        });
      }

      this.motion.load(data.motion);
      this.particles.load(data.particles);
      Utils_1.Plugins.loadOptions(this, data);

      if (data.responsive !== undefined) {
        var _iterator2 = _createForOfIteratorHelper(data.responsive),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var responsive = _step2.value;
            var optResponsive = new Responsive_1.Responsive();
            optResponsive.load(responsive);
            this.responsive.push(optResponsive);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      this.responsive.sort(function (a, b) {
        return a.maxWidth - b.maxWidth;
      });

      if (data.themes !== undefined) {
        var _iterator3 = _createForOfIteratorHelper(data.themes),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var theme = _step3.value;
            var optTheme = new Theme_1.Theme();
            optTheme.load(theme);
            this.themes.push(optTheme);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  }, {
    key: "setTheme",
    value: function setTheme(name) {
      if (name) {
        var chosenTheme = this.themes.find(function (theme) {
          return theme.name === name;
        });

        if (chosenTheme) {
          this.load(chosenTheme.options);
        }
      } else {
        var clientDarkMode = typeof matchMedia !== "undefined" && matchMedia("(prefers-color-scheme: dark)").matches;
        var defaultTheme = this.themes.find(function (theme) {
          return theme.default.value && (theme.default.mode === Enums_1.ThemeMode.dark && clientDarkMode || theme.default.mode === Enums_1.ThemeMode.light && !clientDarkMode);
        });

        if (!defaultTheme) {
          defaultTheme = this.themes.find(function (theme) {
            return theme.default.value && theme.default.mode === Enums_1.ThemeMode.any;
          });
        }

        if (defaultTheme) {
          this.load(defaultTheme.options);
        }
      }
    }
  }, {
    key: "importPreset",
    value: function importPreset(preset) {
      this.load(Utils_1.Plugins.getPreset(preset));
    }
  }, {
    key: "setResponsive",
    value: function setResponsive(width, pxRatio, defaultOptions) {
      var _a;

      this.load(defaultOptions);
      this.load((_a = this.responsive.find(function (t) {
        return t.maxWidth * pxRatio > width;
      })) === null || _a === void 0 ? void 0 : _a.options);
    }
  }]);

  return Options;
}();

exports.Options = Options;